import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { PaginatedResult } from '../model/paginated-result';
import {
  IntegrationTemplate,
  LeadColumn,
  PayloadMapping,
  SchemaField,
} from '../models/integration-template.model';
import { Event } from '../models/event.model';

export interface IntegrationEventPayload {
  name: string;
  description?: string | null;
  payload_example?: string | null;
  payload_schema?: SchemaField[] | null;
  payload_mapping?: PayloadMapping | null;
  is_strict_payload?: boolean;
  /** SMS-013: nichos/segmentos do template (multiselect no Passo 1). */
  operation_types?: string[];
  /** SMS-011c: events com predicate enviados na mesma transação do template. */
  events?: Event[];
}

export interface ListPaginatedParams {
  page: number;
  perPage: number;
  search?: string;
}

@Injectable({ providedIn: 'root' })
export class IntegrationTemplateService {

  private readonly baseUrl = `${environment.apiUrl}/integration-templates`;

  constructor(private http: HttpClient) {}

  listPaginated(params: ListPaginatedParams): Observable<PaginatedResult<IntegrationTemplate[]>> {
    let httpParams = new HttpParams()
      .set('page', String(params.page))
      .set('per_page', String(params.perPage));

    if (params.search) {
      httpParams = httpParams.set('search', params.search);
    }

    return this.http.get<PaginatedResult<IntegrationTemplate[]>>(this.baseUrl, { params: httpParams });
  }

  leadColumns(): Observable<LeadColumn[]> {
    return this.http.get<LeadColumn[]>(`${this.baseUrl}/lead-columns`);
  }

  findById(id: string): Observable<IntegrationTemplate> {
    return this.http.get<IntegrationTemplate>(`${this.baseUrl}/${id}`);
  }

  save(payload: IntegrationEventPayload, id?: string): Observable<IntegrationTemplate> {
    if (id) {
      return this.http.put<IntegrationTemplate>(`${this.baseUrl}/${id}`, payload);
    }

    return this.http.post<IntegrationTemplate>(this.baseUrl, payload);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
